import CheckIcon from "@mui/icons-material/Check";
import { Button, Dialog } from "@mui/material";
import React, { useState } from "react";
import { VendorTicketDetail } from "../../../../@types/DRO/WarrantyTicketsResponse";
import { WarrantyTicketsApi } from "../../../../api/WarrantyTickets/WarrantyTicketsApi";
import { useLoading } from "../../../../views/Loader/LoadingContext";

interface AcceptDialogProps {
  open: boolean;
  row: VendorTicketDetail | null;
  onClose: () => void;
  onSuccess: () => void;
}

const AcceptDialog: React.FC<AcceptDialogProps> = ({ open, row, onClose, onSuccess }) => {
  const { setLoading } = useLoading();
  const [successOpen, setSuccessOpen] = useState(false);

  const handleConfirm = async () => {
    if (!row) return;
    onClose();
    setLoading(true);
    try {
      await WarrantyTicketsApi.api.warrantyTicketAction({
        warrantyActionItems: [{ uid: row.uid, action: "ACCEPT", imageId: row.imageId, remarks: "" }],
      });
      setSuccessOpen(true);
      onSuccess();
    } catch (error) {
      console.error("Error accepting ticket", error);
    }
    setLoading(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ sx: { borderRadius: 3, p: 3, width: 300 } }}>
        <p className="text-center text-gray-800 font-medium mb-5 leading-snug">
          Are you sure you want to<br />Accept the request?
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button
            variant="outlined"
            size="small"
            onClick={onClose}
            sx={{ textTransform: "none", borderColor: "#ccc", color: "#333", "&:hover": { borderColor: "#999" } }}>
            No, Reject
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={handleConfirm}
            sx={{ textTransform: "none", bgcolor: "#2563EB", "&:hover": { bgcolor: "#1D4ED8" } }}>
            Yes, Accept
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        PaperProps={{ sx: { borderRadius: 3, p: 4, width: 280 } }}>
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center">
            <CheckIcon sx={{ color: "white", fontSize: 36 }} />
          </div>
          <p className="text-gray-800 font-semibold text-center">Warranty Request Accepted!</p>
        </div>
      </Dialog>
    </>
  );
};

export default AcceptDialog;
